import { css } from 'lit-element';
import {
  screenLgMin,
  screenMdMin,
  screenSmMax,
  screenSmMin,
  screenXsMax,
} from 'lm-ui-kit/src/utils/response-query';

export function mobile(content) {
  return css`
    @media screen and (max-width: ${screenXsMax}px) {
      ${content}
    }
  `;
}

export function tablet(content) {
  return css`
    @media screen and (min-width: ${screenSmMin}px) {
      ${content}
    }
  `;
}

export function onlyTablet(content) {
  return css`
    @media screen and (min-width: ${screenSmMin}px) and (max-width: ${screenSmMax}px) {
      ${content}
    }
  `;
}

export function desktop(content) {
  return css`
    @media screen and (min-width: ${screenMdMin}px) {
      ${content}
    }
  `;
}

export function notDesktop(content) {
  return css`
    @media screen and (max-width: ${screenSmMax}px) {
      ${content}
    }
  `;
}

export function largeDesktop(content) {
  return css`
    @media screen and (min-width: ${screenLgMin}px) {
      ${content}
    }
  `;
}
